import { MdOutlineChevronLeft, MdOutlineChevronRight } from 'react-icons/md'
import { useSwiper } from 'swiper/react'

interface Props {
  isCardHovered: boolean
}

const Arrows = ({ isCardHovered }: Props) => {
  const swiper = useSwiper()

  const onClick = (direction: 'right' | 'left') => {
    if (swiper.destroyed) {
      return
    }
    if (direction === 'right') {
      swiper.slideNext()
    } else {
      swiper.slidePrev()
    }
  }

  return (
    <div
      className={`w-full h-full flex justify-between items-center duration-500 ease-in-out
     ${isCardHovered ? 'md:opacity-100' : 'md:opacity-0'}
    `}
    >
      <button
        data-testid="arrow-button"
        onClick={(event: { stopPropagation: () => void }) => {
          event.stopPropagation()
          onClick('left')
        }}
        role="button"
        tabIndex={0}
        type="button"
        className="w-[50px] h-full flex justify-end items-center bg-transparent active:scale-75 duration-200"
      >
        <MdOutlineChevronLeft className="w-[34px] h-[34px] fill-white" />
      </button>
      <button
        onClick={(event: { stopPropagation: () => void }) => {
          event.stopPropagation()
          onClick('right')
        }}
        role="button"
        tabIndex={0}
        type="button"
        className="w-[50px] h-full flex justify-start items-center bg-transparent active:scale-75 duration-200"
      >
        <MdOutlineChevronRight className="w-[34px] h-[34px] fill-white" />
      </button>
    </div>
  )
}

export default Arrows
